import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./global.css";
import "./components/Footer.css"

import Header from "./components/Header";
import axios from "axios";
import { API_IP } from "./global_variables";
import ReactDOM from "react-dom";
import LoginForm from "./components/LoginForm";
import ForgotPassword from "./components/ForgotPassword";
import Registration from "./components/Registration";
import CareProviderProfile from "./components/CareProviderProfile";
import Dashboard from "./components/UserLanding";
import HomePage from "./components/HomePage";
import ProviderSelection from "./components/ProviderSelection";
import UserLanding from "./components/UserLanding";
import Messaging from "./components/Mesaging";
import React, { useEffect, useState } from "react";
import AuthRoute from "./components/AuthRoute";
import UserProfileScreen from "./components/UserProfileScreen";
import UserWelcomeScreen from "./components/UserWelcomeScreen";
import CareServiceProfile from "./components/CareServiceProfile";
import { Elements } from "@stripe/react-stripe-js";
import Tutorial from "./components/TutorialComponent/Tutorial";
import CheckoutForm from "./components/AccountComponents/PaymentForm";
import ServiceSelection from "./components/ServiceSelection";
import ContactUsPage from "./components/ContactUsPage";
import BookConsultation from "./components/BookConsultation";
import CareerPage from "./components/CareerPage";
import AboutUsPage from "./components/AboutUsPage";
import AboutLeadership from "./components/AboutLeadership";
import { amityLogin } from "./components/Amity/AmityProvider.ts";
import PlatformOrientation from "./components/PlatformOrientation";

const App = () => {
  const [user, setUser] = useState({ username: "", userId: "" });
  const [loggedIn, setLogin] = useState(false);
  const [selectedSection, setSelectedSectionState] = useState(
    () => sessionStorage.getItem("selectedSection") || "Patient"
  );
  const setSelectedSection = (value) => {
    sessionStorage.setItem("selectedSection", value);
    setSelectedSectionState(value);
  };
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [selectedCareService, setSelectedCareService] = useState("");
  const [isTutorialVisible, setIsTutorialVisible] = useState(false);
  const [tutorialSteps, setTutorialSteps] = useState([]);
  const [services, setServices] = useState([]);

  const getServices = async () => {
    axios
      .get(`${API_IP}/api/services`)
      .then((response) => {
        setServices(response.data);
      })
      .catch((error) => {
        console.error("There was an error fetching the providers!", error);
      });
  };

  const toggleSidebar = (value) => {
    if (value === undefined) {
      setSidebarOpen(!isSidebarOpen);
    } else {
      setSidebarOpen(value);
    }
  };
  const location = useLocation();
  const currentPath = location.pathname;
  const tutorialInMain = [
    {
      content: "Here is where you can check your message",
      targetSelector: "#messages-button",
    },
    {
      content: "You can book a service and check all your requests.",
      targetSelector: "#schedule-button",
    },
    {
      content: "See all provider that are available around you.",
      targetSelector: "#provider-button",
    },
    {
      content: "Check your billing information.",
      targetSelector: "#invoices-button",
    },
    {
      content: "Inspect your account information.",
      targetSelector: "#account-button",
    },
    // ... more steps
  ];
  const tutorialTrigger = () => {
    switch (currentPath) {
      case "/main":
        setTutorialSteps(tutorialInMain);
        setIsTutorialVisible(true);
        break;
      case "/login":
        break;
      default:
        alert("This page does not have a tutorial.");
        break;
    }
  };

  const keepLogingIn = async () => {
    const token =
      localStorage.getItem("token") || sessionStorage.getItem("token");
    if (token != null) {
      const userId =
        localStorage.getItem("userId") || sessionStorage.getItem("userId");
      const username =
        localStorage.getItem("username") || sessionStorage.getItem("username");

      if (userId && username) {
        try {
          await amityLogin("A" + userId, username);
        } catch (error) {
          console.log("Amity login failed (App.js):", error);
        }
      }
      setLogin(true);
    } else {
      setLogin(false);
    }
  };
  useEffect(() => {
    keepLogingIn();
    getServices();
  }, []);
  return (
    <>
      <Header
        loggedIn={loggedIn}
        setLogin={setLogin}
        toggleSidebar={toggleSidebar}
        setSelectedSection={setSelectedSection}
        setSelectedCareService={setSelectedCareService}
      />
      <div className="mainBody">
        {/* <button
          onClick={() => {
            tutorialTrigger();
          }}
          className="sidebar-help"
        >
          <p>Tutorial</p>
        </button>
        {isTutorialVisible ? (
          <Tutorial
            steps={tutorialSteps}
            setIsTutorialVisible={setIsTutorialVisible}
          />
        ) : (
          <></>
        )} */}

        <Routes>
          <Route path="/" element={<HomePage loggedIn={loggedIn} />} />
          <Route path="/ContactUs" element={<ContactUsPage />} />"
          <Route path="/register/*" element={<Registration />} />
          <Route
            path="/platform-orientation"
            element={<PlatformOrientation />}
          />
          <Route
            path="/consultation"
            element={<BookConsultation services={services} />}
          />
          <Route
            path="/Services"
            element={<ServiceSelection services={services} />}
          />
          <Route path="/Careers" element={<CareerPage />} />\
          <Route path="/AboutUs" element={<AboutUsPage />} />
          <Route path="/OurLeadership" element={<AboutLeadership />} />
          {/* <Route
            path="/CareProviderProfile"
            element={
              <CareProviderProfile setSelectedSection={setSelectedSection} />
            }
          /> */}
          <Route
            path="/Providers"
            element={
              <ProviderSelection setSelectedSection={setSelectedSection} />
            }
          />
          <Route
            path="/login"
            element={
              <LoginForm
                setUser={setUser}
                setLogin={setLogin}
                loggedIn={loggedIn}
              />
            }
          />
          <Route
            path="/CareProviderProfile"
            element={
              <AuthRoute
                element={
                  <CareProviderProfile
                    setSelectedSection={setSelectedSection}
                  />
                }
              />
            }
          />
          <Route
            path="/CareServiceProfile"
            element={
              <CareServiceProfile
                setSelectedSection={setSelectedSection}
                selectedCareService={selectedCareService}
                loggedIn={loggedIn}
              />
            }
          />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route
            path="/Dashboard"
            element={<AuthRoute element={<Dashboard />} />}
          />
          <Route
            path="/main"
            element={
              <AuthRoute
                element={
                  <UserWelcomeScreen setSelectedSection={setSelectedSection} />
                }
              />
            }
          />
          <Route
            path="/home"
            element={<AuthRoute element={<HomePage loggedIn={loggedIn} />} />}
          />
          {/* <Route
            path="/Providers"
            element={
              <AuthRoute
                element={
                  <ProviderSelection setSelectedSection={setSelectedSection} />
                }
              />
            }
          /> */}
          <Route
            path="/UserHome"
            element={
              <AuthRoute
                element={
                  <UserLanding
                    setSelectedSection={setSelectedSection}
                    selectedSection={selectedSection}
                    toggleSidebar={toggleSidebar}
                    services={services}
                    isSidebarOpen={isSidebarOpen}
                    setLogin={setLogin}
                  />
                }
              />
            }
          />
          <Route
            path="/UserProfile"
            element={<AuthRoute element={<UserProfileScreen />} />}
          />
        </Routes>
      </div>
      <div className="footer">
        <p>© iCareVillage - Home Care 2025. All rights reserved</p>
        <p>
          iCare Village provides non-medical in-home support services. Services
          are delivered by iCare Village care staff and supported by our
          technology platform for scheduling, communication, and care
          coordination
        </p>
      </div>
    </>
  );
};

export default App;
